import React, { useState, useEffect } from "react";
import { Switch, Route, Link, useLocation } from "react-router-dom";
import "../styles/SocialProject.scss";
import Api from "../common/api";

const SocialProject = (id) => {
  console.log(id);
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([
    {
      id: 1,
      name: "Ocak",
    },
    {
      id: 2,
      name: "Şubat",
    },
    {
      id: 3,
      name: "Mart",
    },
    {
      id: 4,
      name: "Nisan",
    },
    {
      id: 5,
      name: "Mayıs",
    },
    {
      id: 6,
      name: "Haziran",
    },
    {
      id: 7,
      name: "Temmuz",
    },
    {
      id: 8,
      name: "Ağustos",
    },
    {
      id: 9,
      name: "Eylül",
    },
    {
      id: 10,
      name: "Ekim",
    },
    {
      id: 11,
      name: "Kasım",
    },
    {
      id: 12,
      name: "Aralık",
    },
  ]);

  const [currentTab, setCurrentTab] = useState([]);
  const [currentTabId, setCurrentTabId] = useState([]);
  const [currentSubTab, setCurrentSubTab] = useState([]);
  const [currentTabSubId, setCurrentSubTabId] = useState([]);
  const [newsId, setNewsId] = useState(null);
  const [isNewActive, setIsNewActive] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [datas, setData] = useState([]);
  const [filterDatas, filterData] = useState([]);
  const [activeYear, setActiveYear] = useState([]);
  const [filterMonths, setFilterMonths] = useState([]);
  const [activeMonth, setActiveMonth] = useState([]);

  const [selectedNews, setSelected] = useState([]);
  const lang = localStorage.getItem("lang");

  let size = 3;
  if(lang == "en"){
    size = 4;
  }

  const [activeNews, setActiveNews] = useState(
    useLocation().pathname.split("/")[size]
  );

  React.useEffect(() => {
    if(activeNews != ""){
      Api.get("/News/detail?slug=" + activeNews).then((res) => {
        setSelected(res.data);
      });
    } 

    Api.get("/News/list/"+id.id).then((res) => {
      setData(res.data.items);
      console.log("fonksiyona girdi");
      var year = [];
      res.data.items.map((val, index) => {
        console.log("hesaplanmış tarih : " + new Date(val.Created_date.split("(")[1].split(")")[0] * 1)
        .toLocaleDateString("tr-TR")
        .split(".")[2]);
        var newYear = new Date(val.Created_date.split("(")[1].split(")")[0] * 1)
          .toLocaleDateString("tr-TR")
          .split(".")[2];
        if (year.findIndex((x) => x.name == newYear) == -1) {
          year.push({
            id: index,
            name: newYear,
          });
        }
      });
      setYears(year);
      setActiveYear([]);
      setCurrentTabId(null);
    });
  }, []);

  //  filter here
  React.useEffect(() => {
    var newmonth = [];
    var filtered = "";
    if (activeYear.length != 0) {
      filtered = datas.filter((x) =>
        activeYear.length > 0
          ? new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
              .toLocaleDateString("tr-TR")
              .split(".")[2] == activeYear
          : null
      );

      var filteredSelectedmonth = months.find((m) => m.name == activeMonth);
      if (activeMonth.length != 0 && filteredSelectedmonth) {
        filtered = filtered.filter((x) =>
          activeMonth.length > 0
            ? new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
                .toLocaleDateString("tr-TR")
                .split(".")[1] == filteredSelectedmonth.id
            : null
        );
      }

      datas.filter((x, index) => {
        if (
          new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
            .toLocaleDateString("tr-TR")
            .split(".")[2] == activeYear
        ) {
          var month = new Date(x.Created_date.split("(")[1].split(")")[0] * 1)
            .toLocaleDateString("tr-TR")
            .split(".")[1];
          if (month < 10) {
            month = month.replace("0", "");
          }
          // if months is a list not add again
          if (months.findIndex((y) => x.id == month) == -1) {
            if (!newmonth.find((z) => z.id == month)) {
              if (months) {
                newmonth.push({
                  id: months[0].id ? months.find((c) => c.id == month).id : "",
                  name: months.find((d) => d.id == month).name,
                });
              }
            }
          }
        }
      });
      setFilterMonths(newmonth);
      filterData(filtered);
    } else {
      filterData(datas);
    }
  }, [activeYear, activeMonth]);

  const adClick = (id) => {
    setCurrentTabId(id);
    const tab = years.find((tab) => tab.id === id);
    setCurrentTab(tab);
    setIsActive(!isActive);
    if (id == currentTabId) {
      setCurrentTabId(null);
    } else {
      setCurrentTabId(id);
    }
  };

  const adClickTwo = (id) => {
    setCurrentSubTabId(id);
    const tab = months.find((tab) => tab.id === id);
    setCurrentSubTab(tab);
    if (id == currentTabSubId) {
      setCurrentSubTabId(null);
    } else {
      setCurrentSubTabId(id);
    }
  };

  const allClick = () => {
    setCurrentTabId(null);
    setActiveYear([]);
  };

  return (
    <>
    
      <div className="corporate-content-container full-width container-sm">
  
        <div className="corporate-container">
        {selectedNews ?
          lang == "en" ?(
            <div className="new-container white">
                        
            <div className="new-content-box">
            
              <h5>
                {selectedNews.Created_date
                  ? new Date(
                      selectedNews.Created_date.split("(")[1].split(")")[0] *
                        1
                    ).toLocaleDateString("tr-TR")
                  : null}
              </h5>
              <h4>{selectedNews.Title_EN}</h4>
              <div className="flex">
              <div className="new-img-box">
              <img
                src={"https://sankoenerji.com.tr" + selectedNews.Image}
                alt=""
                 
              />
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: selectedNews.Content_EN,
                }}
              >
              </div>
            </div>
            </div>
          </div>
          ):
          (
            <div className="new-container white">
                        
              <div className="new-content-box">
              
                <h5>
                  {selectedNews.Created_date
                    ? new Date(
                        selectedNews.Created_date.split("(")[1].split(")")[0] *
                          1
                      ).toLocaleDateString("tr-TR")
                    : null}
                </h5>
                <h4>{selectedNews.Title}</h4>
                <div className="flex">
                <div className="new-img-box">
                <img
                  src={"https://sankoenerji.com.tr" + selectedNews.Image}
                  alt=""
                   
                />
                </div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: selectedNews.Content,
                  }}
                >
                </div>
              </div>
              </div>
            </div>
          ) : filterDatas ? (

            lang == "en" ? (
              <>
              <h3>{lang == "en" ? "Our Works" : "Çalışmalarımız"}</h3>
              {filterDatas.map((data) => (
              data.Title_EN ? (
                <div key={data.id} className="new-container news-list">
                <div className="new-img-box">
                  {data.Image ? (
                    <img
                      src={"https://sankoenerji.com.tr" + data.Image}
                      alt=""
                    />
                  ) : null}
                </div>
                <div className="new-content-box">
                  <h5>
                    {data.Created_date
                      ? new Date(
                          data.Created_date.split("(")[1].split(")")[0] * 1
                        ).toLocaleDateString("tr-TR")
                      : null}
                  </h5>
                  <h4>{lang == "en" ? data.Title_EN : data.Title}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: lang == "en" ? data.Spot_EN : data.Spot,
                    }}
                  ></p>
                </div>
                {lang =="en" ? (
                <button style={{ textDecoration: "none", color: "black" }}>
                  <a href={"/en/sustainability/Our-Social-Responsibility-Projects/" + data.Slug_EN}>
                    read more
                  </a>
                </button>
                ):(
                  <button style={{ textDecoration: "none", color: "black" }}>
                  <a href={"/surdurulebilirlik/sosyal-sorumluluk-projelerimiz/" + data.Slug}>
                    Haberin devamı için tıklayın
                  </a>
                </button>
                )}
              </div>
            ):""

            ))}
            </>
            ):(
              <>
              <h3>{lang == "en" ? "Our Works" : "Çalışmalarımız"}</h3>
              {filterDatas.map((data) => (
                <div key={data.id} className="new-container news-list">
                <div className="new-img-box">
                  {data.Image ? (
                    <img
                      src={"https://sankoenerji.com.tr" + data.Image}
                      alt=""
                    />
                  ) : null}
                </div>
                <div className="new-content-box">
                  <h5>
                    {data.Created_date
                      ? new Date(
                          data.Created_date.split("(")[1].split(")")[0] * 1
                        ).toLocaleDateString("tr-TR")
                      : null}
                  </h5>
                  <h4>{lang == "en" ? data.Title_EN : data.Title}</h4>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: lang == "en" ? data.Spot_EN : data.Spot,
                    }}
                  ></p>
                </div>
                {lang =="en" ? (
                <button style={{ textDecoration: "none", color: "black" }}>
                  <a href={"/en/sustainability/Our-Social-Responsibility-Projects/" + data.Slug_EN}>
                    read more
                  </a>
                </button>
                ):(
                  <button style={{ textDecoration: "none", color: "black" }}>
                  <a href={"/surdurulebilirlik/sosyal-sorumluluk-projelerimiz/" + data.Slug}>
                    Haberin devamı için tıklayın
                  </a>
                </button>
                )}
              </div>
              ))}
            </>
            )

            
          ) : null}
          
        </div>
      </div>      
    </>
  );
};
export default SocialProject;
